/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UniversalRouterVersion {
    _1_2 = '1.2',
    _2_0 = '2.0',
}
